import { FilterOperator, getTransactionsByCriteria } from '@nemuru-eng/js-api-client';

import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useTransactionsList({ payoutId }: { payoutId: string }) {
  const payoutIdFilter = [
    {
      field: 'payout_id',
      operator: FilterOperator.EQUAL,
      value: payoutId,
    },
  ];
  const fetchTransactionsList = async (query) => {
    const customFilters = payoutIdFilter.concat(query?.filters);
    return fetchForDataGrid(getTransactionsByCriteria, { ...query, filters: customFilters });
  };

  return {
    fetchTransactionsList,
  };
}
